import { render, staticRenderFns } from "./nodalLedgerList.vue?vue&type=template&id=67573231"
import script from "./nodalLedgerList.vue?vue&type=script&lang=js"
export * from "./nodalLedgerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports